const BookingMain = () => import(/* webpackChunkName: "admin-module" */ './index');
const Bookings = () => import(/* webpackChunkName: "admin-module" */ './views/Bookings');
const Create = () => import(/* webpackChunkName: "admin-module" */ './views/Create');
const Edit = () => import(/* webpackChunkName: "admin-module" */ './views/Edit');
const Show = () => import(/* webpackChunkName: "admin-module" */ './views/Show');

export default [
    {
        path: 'booking',
        components: { base: BookingMain },
        children: [
            {
                path: '',
                name: 'bookings',
                components: { booking: Bookings }
            },
            {
                path: 'create',
                name: 'booking.create',
                components: { booking: Create }
            },
            {
                path: ':booking_id/show',
                name: 'booking.show',
                components: { booking: Show }
            },
            {
                path: ':booking_id/edit',
                name: 'booking.edit',
                components: { booking: Edit }
            },
        ]
    },
];
